<template>
    <div class="news-list">
        <div class="page">
            <h1 class="page-title title">{{ $t("dashboard.label.news") }}</h1>
            <div class="page-ct">
                <div class="notification">
                    <div class="section">
                        <h4 class="box-title title">
                            <span>{{ $t("dashboard.label.news_list") }}</span>
                        </h4>
                        <div class="box-ct">
                            <div class="news-filter">
                                <form class="form-inline">
                                    <label class="mr-1">{{$t("dashboard.label.service")}}</label>
                                    <div class="form-group">
                                        <dropdown-select classProps="ServiceType"
                                                         :items="dropDownItems"
                                                         @onSelect="input['condition.serviceType'] = $event">
                                        </dropdown-select>
                                    </div>
                                    <label class="mr-1">{{ $t("dashboard.label.category")}}</label>
                                    <div class="form-group">
                                        <dropdown-select
                                                classProps="MessageKind"
                                                :items="convertMessage(mapMessageKind)"
                                                @onSelect="input['condition.messageKind'] = $event"
                                        ></dropdown-select>
                                    </div>
                                    <div class="form-group">
                                        <label class="checkbox">
                                            <input class="mr-1" type="checkbox" v-model="input['condition.readFlg']"/>
                                            {{ $t("dashboard.label.read_flg") }}
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-success" @click.prevent="searchNews()">
                                            {{ $t("btn.search") }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <hr/>

                            <ul class="notification-list" v-if="model && model.listAmsCustomerNewsView.length !== 0">
                                <li :class="isRead(item.readFlg)" v-for="item in model.listAmsCustomerNewsView" :key="item.messageId" :id="item.messageId">
                                    <span class="notification-item-date">{{item.startDate | formatDate("DD-MM-YYYY hh:mm:ss", "YYYY/MM/DD")}}</span>
                                    <span :class="colorMessageKind(item.messageKind)">{{ item.messageKind | textMessageKind }}</span>
                                    <span>{{ item.serviceType | textServiceTypePopup }}</span>
                                    <a
                                            @click="openNews(item)"
                                            class="notification-item-title"
                                            v-html="item.messageTitle"
                                            style="cursor: pointer; word-break: break-word"
                                    ></a>
                                </li>
                            </ul>
                            <p v-else class="nodata">{{ $t("nodata.found") }}</p>
                            <hr/>
                            <div style="padding: 25px" v-if="model.listAmsCustomerNewsView.length !== 0">
                                <pagination
                                        :total-pages="totalPage"
                                        :total="totalItems"
                                        :per-page="offset"
                                        :current-page="currentPage"
                                        @pagechanged="onPageChange"
                                        @pageJump="onPageJump"
                                        :previousText="$t('navigation.bt.previous')"
                                        :nextText="$t('navigation.bt.next')"
                                        :firstText="$t('navigation.bt.first')"
                                        :lastText="$t('navigation.bt.last')"
                                ></pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * @author HungNS
     */
    export default {
        data: function () {
            return {
                SERVICE_NAME: "dashboard",
                dropDownItems: [
                    {key: 0, value: this.$t("default.combo.box"), default: true},
                    {key: 21, value: "FX"},
                    {key: 31, value: "コイン"},
                ],
                model: {
                    listAmsCustomerNewsView: [],
                },
                totalPage: 0,
                totalItems: 0,
                offset: 0,
                currentPage: 1,
                mapMessageKind: this.IConstants.mapMessageKind(),
                input: {
                    "condition.serviceType": 0,
                    "condition.messageKind": 0,
                    "condition.readFlg": false,
                },
                listMessageKind: this.IConstants.MESSAGE_KIND,
            };
        },
        methods: {
            onPageChange: function (page) {
                this.currentPage = page;
                this.searchNews();
            },
            onPageJump: function (page, previous, next, maxVisibleButtons) {
                this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
                this.searchNews();
            },
            searchNews: function () {
                const config = {
                    "condition.serviceType": this.input["condition.serviceType"],
                    "condition.messageKind": this.input["condition.messageKind"],
                    "condition.readFlg": this.input["condition.readFlg"],
                    "condition.offset": this.currentPage
                };
                this.$service
                    .getService(this.SERVICE_NAME)
                    .getCustomerNews(config)
                    .then((response) => {
                        this.model = response;
                        if (response.pagingInfo != null) {
                            this.totalPage = response.pagingInfo.totalPage === 0 ? 1 : response.pagingInfo.totalPage;
                            this.totalItems = response.pagingInfo.total;
                            this.offset = response.pagingInfo.offset;
                        } else {
                            this.totalItems = 0;
                            this.offset = 10;
                        }
                    });
            },
            openNews(item) {
                let self = this;
                let callbackFunction = async () => {
                    let config = {
                        readFlg : item.readFlg,
                        messageId : item.messageId,
                        messageType : item.messageType
                    };
                    const response = await self.$service.getService(self.SERVICE_NAME).agreeNews(config);
                    if(response.errorMessage){
                        self.errorMessage = response.errorMessage
                    } else {
                        let child = document.getElementById(item.messageId);
                        child.setAttribute('class',this.IConstants.MARK_AS_READ_CLASS.READ);
                    }
                    await self.searchNews()
                };
                this.$modal.showNewsInfo(this.prepareDataToOpenNewsInfo(item, false, callbackFunction));
            },
            convertMessage(list) {
                const result = [];
                list.map((item) => {
                    result.push({
                        key: item.key,
                        value: this.$t(item.value),
                    });
                });
                return result;
            },
        },
        created() {
            this.searchNews();
        },
    };
</script>

<style scoped>
    .news-filter {
        margin-bottom: 30px;
        margin-right: 5px;
    }

    @media screen and (max-width: 767px) {
        .news-filter {
            display: flex;
            flex-flow: column wrap;
        }
        .news-filter div {
            width: 100%;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 979px) {
      .news-filter .form-inline .form-group {
        margin-bottom: 10px;
        margin-right: 15px;
      }
    }
</style>
